import React from 'react';
import { createAppSwitcherBffAvailableProductsProvider } from './app-switcher-bff-available-products-provider';
var _ref = createAppSwitcherBffAvailableProductsProvider(),
  fetchAppSwitcherBffAvailableProducts = _ref.fetchMethod,
  DefaultBffDataProviderComponent = _ref.ProviderComponent;
export var AvailableProductsProvider = function AvailableProductsProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(DefaultBffDataProviderComponent, null, children);
};
export var prefetchAvailableProducts = function prefetchAvailableProducts() {
  return fetchAppSwitcherBffAvailableProducts({});
};
export var resetAvailableProducts = function resetAvailableProducts() {
  return fetchAppSwitcherBffAvailableProducts.reset();
};